import {CustomFieldTO} from 'generated/JavaTO'
import {CFModel} from 'module/CustomField/type/CFType'
import _ from 'lodash'
import {CF} from 'module/CustomField/util/CustomField'

export function getGroupedCFMissingNullValues(cfDefs: CustomFieldTO[], model: CFModel): { cfDef: CustomFieldTO, pos: number }[] {
	return Object.entries(_.groupBy(cfDefs, 'cfGroupId')).flatMap(([groupIdKey, cfDefs]) => {
		const groupId = +groupIdKey
		if (!groupId && groupId !== 0) return [];
		const allPos = CF.getPositions(cfDefs, model)
		return cfDefs.flatMap(cfDef => {
			const singleCFPos = CF.getPositions([cfDef], model)
			let len = singleCFPos.length
			return allPos.flatMap(pos => {
				if (len < cfDef.maxAmount && (pos || pos === 0) && !singleCFPos.includes(pos)) {
					len++
					return [{cfDef, pos}]
				}
				return []
			})
		})
	})
}